import BaseService from './base.service';

class ProductService extends BaseService {
  get basePath() {
    return 'products';
  }
}

export default new ProductService();
